import { breakpoints, spacing } from '@naf/theme';
import { Text } from '@naf/text';
import styled from '@emotion/styled';
import { ExpandMore } from '@styled-icons/material-outlined';
import { isNotTransientProp } from '@lib/shouldForwardProp';

export const HeaderWrapper = styled.div`
  grid-column: auto / span 12;
  max-width: calc(100vw - ${spacing.space48});
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.space16};
  flex-shrink: 0;
`;

export const Title = styled.h2<{ $size?: string }>`
  font-size: ${({ $size }) => ($size === 'large' ? '3rem' : '1.75rem')};
  font-weight: 900;
  line-height: 1;
`;

export const Chevron = styled(ExpandMore, { shouldForwardProp: isNotTransientProp })<{ $isOpen: boolean }>`
  height: 20px;
  width: 20px;
  margin-left: ${spacing.space8};
  transition: ease-in-out 0.2s;
  transform: translateY(-2px) rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0')});
`;

export const SubGrid = styled.div<{ $extraMarginBottom?: boolean }>`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;
  row-gap: 0;
  max-width: calc(100vw - ${spacing.space48});
  ${({ $extraMarginBottom }) => $extraMarginBottom && `margin-bottom: ${spacing.space48};`}

  @media (min-width: ${breakpoints.m}) {
    gap: ${spacing.space24};
    row-gap: 0;
  }

  @media (min-width: ${breakpoints.l}) {
    gap: ${spacing.space32};
    row-gap: 0;
  }
`;

export const EmptyState = styled.div`
  grid-column: 1 / -1;
  padding: ${spacing.space16} 0;
`;

export const EmptyStateText = styled(Text)`
  margin: 0;
`;

export const BenefitCarouselWrapper = styled.div`
  grid-column: 1 / -1;
  transform: translateX(-3px);

  /* MobileCarousel clips card content to its rounded corners, which cuts off the campaign tag CardBenefitPartner
     draws above its top edge. The card already rounds its own image, so it doesn't need the clip. */
  [data-mobile-carousel-track] > div > a:first-of-type {
    overflow: visible;
  }
`;

export const AnimatedFiltersContainer = styled.div<{ $isVisible: boolean; $height?: number }>`
  max-height: ${(props) => {
    if (props.$isVisible) {
      return props.$height ? `${props.$height}px` : '1000px';
    }
    return '0';
  }};
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.2s ${(props) => (props.$isVisible ? '0.1s' : '0s')} ease-in-out;
  margin-bottom: ${(props) => (props.$isVisible ? spacing.space16 : '0')};
  transition-property: max-height, opacity, margin-bottom;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding: ${spacing.space8} 0;

  @media (max-width: ${breakpoints.m}) {
    max-width: calc(100vw - ${spacing.space48});
    margin-bottom: ${spacing.space8};
  }
`;

export const CategoryButtonWrapper = styled.div`
  width: calc(100vw - ${spacing.space48});
  display: flex;
  flex-direction: row-reverse;
`;

export const CategoryButton = styled(Text, { shouldForwardProp: isNotTransientProp })<{ $disabled: boolean }>`
  margin-bottom: ${spacing.space8};
  position: relative;
  ${({ $disabled }) => $disabled && 'disabled: true;'}
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
